import Button from "@material-ui/core/Button";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import PetsIcon from "@material-ui/icons/Pets";


function VacunaAntirrabicaInfo({ textoVacuna, volver }) {
    return (
        <>
            <Button style={{ color: "#4973b3" }} onClick={volver}>
                <ArrowBackIcon fontSize="large" />
            </Button>
            <div>
                <div>
                    <PetsIcon style={{ fontSize: "3em", color: "brown" }} />
                    <PetsIcon style={{ fontSize: "3em", color: "brown" }} />
                    <PetsIcon style={{ fontSize: "3em", color: "brown" }} />
                    <PetsIcon style={{ fontSize: "3em", color: "brown" }} />
                    <PetsIcon style={{ fontSize: "3em", color: "brown" }} />
                    <PetsIcon style={{ fontSize: "3em", color: "brown" }} />
                </div>
                <div dangerouslySetInnerHTML={{ __html: textoVacuna }} ></div>
                <div>
                    <PetsIcon style={{ fontSize: "3em", color: "brown" }} />
                    <PetsIcon style={{ fontSize: "3em", color: "brown" }} />
                    <PetsIcon style={{ fontSize: "3em", color: "brown" }} />
                    <PetsIcon style={{ fontSize: "3em", color: "brown" }} />
                    <PetsIcon style={{ fontSize: "3em", color: "brown" }} />
                    <PetsIcon style={{ fontSize: "3em", color: "brown" }} />
                </div>
            </div>
        </>
    );
}
/*

    • PLAZA UCRANIA
Martes a Sábados
De 10 a 13 hs.

*/
export default VacunaAntirrabicaInfo;
